import { api, useQuery } from '../api.js'
import { Alert, Panel, Pill } from '../components/ui.js'

export function Audit() {
  const rows = useQuery(() => api.audit.list.query({ limit: 100 }), [], { pollMs: 15_000 })
  const chain = useQuery(() => api.audit.verifyChain.query(), [])

  return (
    <div className="space-y-6">
      {chain.data && (
        <Alert tone={chain.data.ok ? 'ok' : 'crit'}>
          {chain.data.ok ? (
            <>
              Cadeia integra — {chain.data.checked} linhas verificadas. Nenhuma foi alterada desde a
              gravacao.
            </>
          ) : (
            <>
              <strong>Cadeia quebrada</strong> na linha {chain.data.brokenAt}. Alguem alterou
              audit_log direto no banco. Investigue antes de qualquer outra coisa.
            </>
          )}
        </Alert>
      )}

      <Panel title="Trilha de auditoria">
        <div className="overflow-x-auto">
          <table className="w-full min-w-[820px] border-collapse text-sm">
            <thead>
              <tr className="border-b border-line text-left font-mono text-[10px] uppercase tracking-[0.12em] text-ink-3">
                <th className="py-2 pr-4">#</th>
                <th className="py-2 pr-4">Quando</th>
                <th className="py-2 pr-4">Acao</th>
                <th className="py-2 pr-4">Alvo</th>
                <th className="py-2 pr-4">Origem</th>
                <th className="py-2">Step-up</th>
              </tr>
            </thead>
            <tbody>
              {(rows.data ?? []).map((r) => (
                <tr key={r.id} className="border-b border-line last:border-0">
                  <td className="py-2.5 pr-4 font-mono text-xs text-ink-3">{r.seq}</td>
                  <td className="py-2.5 pr-4 font-mono text-xs">
                    {new Date(r.ts).toLocaleString('pt-BR')}
                  </td>
                  <td className="py-2.5 pr-4 font-mono text-xs">{r.action}</td>
                  <td className="py-2.5 pr-4 font-mono text-xs text-ink-3">
                    {r.targetType ? `${r.targetType}:${r.targetId?.slice(-8)}` : '—'}
                  </td>
                  <td className="py-2.5 pr-4 font-mono text-xs text-ink-3">{r.actorIp ?? '—'}</td>
                  <td className="py-2.5">
                    {r.stepUpProofId ? <Pill tone="accent">sim</Pill> : <span className="text-ink-3">—</span>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Panel>
    </div>
  )
}
